import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { propTypes } from '../../../util/types';

import css from './SearchMapGroupLabel.module.css';

const TAP_MOVE_THRESHOLD_PX = 10;

class SearchMapGroupLabel extends Component {
  constructor(props) {
    super(props);
    this.touchStartCoords = null;
    this.suppressClick = false;
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.handleTouchCancel = this.handleTouchCancel.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.stopMapInteraction = this.stopMapInteraction.bind(this);
  }

  activate(e) {
    e.preventDefault();
    e.stopPropagation();

    this.props.onListingClicked(this.props.listings);
  }

  handleTouchStart(e) {
    e.stopPropagation();
    this.props.onLabelInteractionStart?.();

    const touch = e.touches[0];
    if (touch) {
      this.touchStartCoords = { x: touch.clientX, y: touch.clientY };
    }
  }

  handleTouchEnd(e) {
    e.stopPropagation();
    this.props.onLabelInteractionEnd?.();

    const touch = e.changedTouches[0];
    if (!touch || !this.touchStartCoords) {
      return;
    }

    const dx = touch.clientX - this.touchStartCoords.x;
    const dy = touch.clientY - this.touchStartCoords.y;
    this.touchStartCoords = null;

    if (Math.hypot(dx, dy) > TAP_MOVE_THRESHOLD_PX) {
      return;
    }

    e.preventDefault();
    this.suppressClick = true;
    window.setTimeout(() => {
      this.suppressClick = false;
    }, 450);

    this.activate(e);
  }

  handleTouchCancel(e) {
    e.stopPropagation();
    this.touchStartCoords = null;
    this.props.onLabelInteractionEnd?.();
  }

  handleClick(e) {
    if (this.suppressClick) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    this.activate(e);
  }

  stopMapInteraction(e) {
    e.stopPropagation();
  }

  shouldComponentUpdate(nextProps) {
    const hasSameAmountOfListings = nextProps.listings.length === this.props.listings.length;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

    return !(hasSameAmountOfListings && hasSameActiveStatus && hasSameRefreshToken);
  }

  render() {
    const { className, rootClassName, listings, isActive } = this.props;
    const classes = classNames(rootClassName || css.root, className);
    const countLabelClasses = classNames(css.details, { [css.detailsActive]: isActive });
    const caretClasses = classNames(css.caret, { [css.caretActive]: isActive });

    return (
      <button
        className={classes}
        type="button"
        onClick={this.handleClick}
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}
        onTouchCancel={this.handleTouchCancel}
        onMouseDown={this.stopMapInteraction}
        data-elbaction={`click:click destp-maplist-${listings[0]?.attributes.title}-uuid-${listings[0]?.id?.uuid}`}
      >
        <div className={css.caretShadow} />
        <div className={countLabelClasses}>{listings.length}</div>
        <div className={caretClasses} />
      </button>
    );
  }
}

SearchMapGroupLabel.defaultProps = {
  className: null,
  rootClassName: null,
};

const { arrayOf, func, string } = PropTypes;

SearchMapGroupLabel.propTypes = {
  className: string,
  rootClassName: string,
  listings: arrayOf(propTypes.listing).isRequired,
  onListingClicked: func.isRequired,
};

export default SearchMapGroupLabel;
